import { navigate } from 'gatsby'
import { useShoppingListStore } from './shoppingListStore'
import { getLocaleUrl } from './localeUtils'
import { isEigenmarkenRolloutEnabled } from './isEigenmarkenRolloutEnabled'

export const openShoppingList = () => {
  // Eigenmarken rollout: the shopping list moves from the sidebar overlay to a
  // dedicated page. The navigation wirings call this handler unchanged; the flag
  // switch lives here centrally.
  if (isEigenmarkenRolloutEnabled()) {
    navigate('/einkaufsliste')
    return
  }

  const path = typeof window !== 'undefined' ? window.location.pathname : ''

  if (useShoppingListStore.getState().shoppingListToggled) {
    navigate(`${path}`)
  } else {
    navigate(`${path}?einkaufsliste=einkaufszettel`)
  }

  useShoppingListStore.setState({
    shoppingListToggled: !useShoppingListStore.getState().shoppingListToggled
  })
}
